import { fetchData, apiURL } from './api_helper';

const historyByMonth = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}histories/${payload.year}/${payload.month}`;
    fetchData(endpointURL, 'get', payload).then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));


const lastWinner = payload => new Promise(((resolve, reject) => {
    const endpointURL = `${apiURL}histories/lastWinner?externalApiKey=${ payload.externalApiKey}`;
    fetchData(endpointURL, 'get').then((result) => {
        resolve(result);
    }).catch((error) => {
        reject(error);
    });
}));

export default {
    historyByMonth,
    lastWinner,
};
